module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 300,
	"w": 420,
	"h": 430,
	"nm": "Partnership_handshake",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": -5,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								218.5,
								232.75,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											6.485,
											12.722
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											91.493,
											-97.889
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 300,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Lager 1/partnership handshake2 Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								210,
								225,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								206,
								206,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 0,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.565,
																134.887
															],
															[
																-180.046,
																128.06
															],
															[
																-186.872,
																111.58
															],
															[
																-163.565,
																88.273
															],
															[
																-124.034,
																88.272
															],
															[
																-107.552,
																95.101
															],
															[
																-100.728,
																111.579
															],
															[
																-107.554,
																128.06
															],
															[
																-124.035,
																134.887
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 95,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.565,
																134.887
															],
															[
																-180.046,
																128.06
															],
															[
																-186.872,
																111.58
															],
															[
																-163.565,
																88.273
															],
															[
																-124.034,
																88.272
															],
															[
																-107.552,
																95.101
															],
															[
																-100.728,
																111.579
															],
															[
																-107.554,
																128.06
															],
															[
																-124.035,
																134.887
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 110,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.065,
																134.887
															],
															[
																-172.546,
																128.06
															],
															[
																-179.372,
																111.58
															],
															[
																-156.065,
																88.273
															],
															[
																-116.534,
																88.272
															],
															[
																-100.052,
																95.101
															],
															[
																-93.228,
																111.579
															],
															[
																-100.054,
																128.06
															],
															[
																-116.535,
																134.887
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 125,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.565,
																134.887
															],
															[
																-180.046,
																128.06
															],
															[
																-186.872,
																111.58
															],
															[
																-163.565,
																88.273
															],
															[
																-124.034,
																88.272
															],
															[
																-107.552,
																95.101
															],
															[
																-100.728,
																111.579
															],
															[
																-107.554,
																128.06
															],
															[
																-124.035,
																134.887
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 140,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.065,
																134.887
															],
															[
																-172.546,
																128.06
															],
															[
																-179.372,
																111.58
															],
															[
																-156.065,
																88.273
															],
															[
																-116.534,
																88.272
															],
															[
																-100.052,
																95.101
															],
															[
																-93.228,
																111.579
															],
															[
																-100.054,
																128.06
															],
															[
																-116.535,
																134.887
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 155,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.226
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.404,
																-4.404
															],
															[
																0.001,
																-6.225
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															]
														],
														"o": [
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.401
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.224,
																0
															],
															[
																4.401,
																4.401
															],
															[
																0.001,
																6.227
															],
															[
																-4.403,
																4.403
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.565,
																134.887
															],
															[
																-180.046,
																128.06
															],
															[
																-186.872,
																111.58
															],
															[
																-163.565,
																88.273
															],
															[
																-124.034,
																88.272
															],
															[
																-107.552,
																95.101
															],
															[
																-100.728,
																111.579
															],
															[
																-107.554,
																128.06
															],
															[
																-124.035,
																134.887
															]
														],
														"c": true
													}
												]
											}
										],
										"ix": 2
									},
									"nm": "finger 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 0,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-179.796,
																70.358
															],
															[
																-186.622,
																53.878
															],
															[
																-163.315,
																30.571
															],
															[
																-123.786,
																30.571
															],
															[
																-107.305,
																37.397
															],
															[
																-100.478,
																53.878
															],
															[
																-123.786,
																77.185
															],
															[
																-163.315,
																77.185
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 95,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-179.796,
																70.358
															],
															[
																-186.622,
																53.878
															],
															[
																-163.315,
																30.571
															],
															[
																-123.786,
																30.571
															],
															[
																-107.305,
																37.397
															],
															[
																-100.478,
																53.878
															],
															[
																-123.786,
																77.185
															],
															[
																-163.315,
																77.185
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 110,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-172.296,
																70.358
															],
															[
																-179.122,
																53.878
															],
															[
																-155.815,
																30.571
															],
															[
																-116.286,
																30.571
															],
															[
																-99.805,
																37.397
															],
															[
																-92.978,
																53.878
															],
															[
																-116.286,
																77.185
															],
															[
																-155.815,
																77.185
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 125,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-179.796,
																70.358
															],
															[
																-186.622,
																53.878
															],
															[
																-163.315,
																30.571
															],
															[
																-123.786,
																30.571
															],
															[
																-107.305,
																37.397
															],
															[
																-100.478,
																53.878
															],
															[
																-123.786,
																77.185
															],
															[
																-163.315,
																77.185
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 140,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-172.296,
																70.358
															],
															[
																-179.122,
																53.878
															],
															[
																-155.815,
																30.571
															],
															[
																-116.286,
																30.571
															],
															[
																-99.805,
																37.397
															],
															[
																-92.978,
																53.878
															],
															[
																-116.286,
																77.185
															],
															[
																-155.815,
																77.185
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 155,
												"s": [
													{
														"i": [
															[
																4.402,
																4.403
															],
															[
																-0.001,
																6.225
															],
															[
																-12.852,
																-0.001
															],
															[
																0,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																-6.226
															],
															[
																12.852,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.403,
																-4.402
															],
															[
																-0.001,
																-12.852
															],
															[
																0,
																0
															],
															[
																6.226,
																-0.001
															],
															[
																4.403,
																4.402
															],
															[
																0,
																12.852
															],
															[
																0,
																0
															],
															[
																-6.226,
																0
															]
														],
														"v": [
															[
																-179.796,
																70.358
															],
															[
																-186.622,
																53.878
															],
															[
																-163.315,
																30.571
															],
															[
																-123.786,
																30.571
															],
															[
																-107.305,
																37.397
															],
															[
																-100.478,
																53.878
															],
															[
																-123.786,
																77.185
															],
															[
																-163.315,
																77.185
															]
														],
														"c": true
													}
												]
											}
										],
										"ix": 2
									},
									"nm": "finger 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 2,
									"ty": "sh",
									"ix": 3,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 0,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.561,
																19.497
															],
															[
																-180.045,
																12.669
															],
															[
																-186.872,
																-3.815
															],
															[
																-163.561,
																-27.126
															],
															[
																-124.039,
																-27.126
															],
															[
																-107.555,
																-20.298
															],
															[
																-100.728,
																-3.814
															],
															[
																-124.039,
																19.497
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 95,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.561,
																19.497
															],
															[
																-180.045,
																12.669
															],
															[
																-186.872,
																-3.815
															],
															[
																-163.561,
																-27.126
															],
															[
																-124.039,
																-27.126
															],
															[
																-107.555,
																-20.298
															],
															[
																-100.728,
																-3.814
															],
															[
																-124.039,
																19.497
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 110,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.061,
																19.497
															],
															[
																-172.545,
																12.669
															],
															[
																-179.372,
																-3.815
															],
															[
																-156.061,
																-27.126
															],
															[
																-116.539,
																-27.126
															],
															[
																-100.055,
																-20.298
															],
															[
																-93.228,
																-3.814
															],
															[
																-116.539,
																19.497
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 125,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.561,
																19.497
															],
															[
																-180.045,
																12.669
															],
															[
																-186.872,
																-3.815
															],
															[
																-163.561,
																-27.126
															],
															[
																-124.039,
																-27.126
															],
															[
																-107.555,
																-20.298
															],
															[
																-100.728,
																-3.814
															],
															[
																-124.039,
																19.497
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 140,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.061,
																19.497
															],
															[
																-172.545,
																12.669
															],
															[
																-179.372,
																-3.815
															],
															[
																-156.061,
																-27.126
															],
															[
																-116.539,
																-27.126
															],
															[
																-100.055,
																-20.298
															],
															[
																-93.228,
																-3.814
															],
															[
																-116.539,
																19.497
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 155,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.403,
																4.403
															],
															[
																-0.001,
																6.227
															],
															[
																-12.854,
																0
															],
															[
																0,
																0
															],
															[
																-4.403,
																-4.404
															],
															[
																0.001,
																-6.227
															],
															[
																12.854,
																0
															]
														],
														"o": [
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																-0.001,
																-12.854
															],
															[
																0,
																0
															],
															[
																6.226,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0.001,
																12.854
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.561,
																19.497
															],
															[
																-180.045,
																12.669
															],
															[
																-186.872,
																-3.815
															],
															[
																-163.561,
																-27.126
															],
															[
																-124.039,
																-27.126
															],
															[
																-107.555,
																-20.298
															],
															[
																-100.728,
																-3.814
															],
															[
																-124.039,
																19.497
															]
														],
														"c": true
													}
												]
											}
										],
										"ix": 2
									},
									"nm": "finger 3",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 3,
									"ty": "sh",
									"ix": 4,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 0,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.906,
																-38.695
															],
															[
																-180.146,
																-45.422
															],
															[
																-186.872,
																-61.662
															],
															[
																-180.146,
																-77.901
															],
															[
																-163.906,
																-84.628
															],
															[
																-123.694,
																-84.628
															],
															[
																-107.454,
																-77.901
															],
															[
																-100.727,
																-61.662
															],
															[
																-123.694,
																-38.695
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 95,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.906,
																-38.695
															],
															[
																-180.146,
																-45.422
															],
															[
																-186.872,
																-61.662
															],
															[
																-180.146,
																-77.901
															],
															[
																-163.906,
																-84.628
															],
															[
																-123.694,
																-84.628
															],
															[
																-107.454,
																-77.901
															],
															[
																-100.727,
																-61.662
															],
															[
																-123.694,
																-38.695
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 110,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.406,
																-38.695
															],
															[
																-172.646,
																-45.422
															],
															[
																-179.372,
																-61.662
															],
															[
																-172.646,
																-77.901
															],
															[
																-156.406,
																-84.628
															],
															[
																-116.194,
																-84.628
															],
															[
																-99.954,
																-77.901
															],
															[
																-93.227,
																-61.662
															],
															[
																-116.194,
																-38.695
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 125,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.906,
																-38.695
															],
															[
																-180.146,
																-45.422
															],
															[
																-186.872,
																-61.662
															],
															[
																-180.146,
																-77.901
															],
															[
																-163.906,
																-84.628
															],
															[
																-123.694,
																-84.628
															],
															[
																-107.454,
																-77.901
															],
															[
																-100.727,
																-61.662
															],
															[
																-123.694,
																-38.695
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 140,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-156.406,
																-38.695
															],
															[
																-172.646,
																-45.422
															],
															[
																-179.372,
																-61.662
															],
															[
																-172.646,
																-77.901
															],
															[
																-156.406,
																-84.628
															],
															[
																-116.194,
																-84.628
															],
															[
																-99.954,
																-77.901
															],
															[
																-93.227,
																-61.662
															],
															[
																-116.194,
																-38.695
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 155,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.338,
																4.338
															],
															[
																-0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																0,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																-6.134
															],
															[
																12.663,
																0
															]
														],
														"o": [
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.337
															],
															[
																-0.001,
																-6.134
															],
															[
																4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																6.135,
																0
															],
															[
																4.338,
																4.337
															],
															[
																-0.001,
																12.664
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-163.906,
																-38.695
															],
															[
																-180.146,
																-45.422
															],
															[
																-186.872,
																-61.662
															],
															[
																-180.146,
																-77.901
															],
															[
																-163.906,
																-84.628
															],
															[
																-123.694,
																-84.628
															],
															[
																-107.454,
																-77.901
															],
															[
																-100.727,
																-61.662
															],
															[
																-123.694,
																-38.695
															]
														],
														"c": true
													}
												]
											}
										],
										"ix": 2
									},
									"nm": "finger 4",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 4,
									"ty": "sh",
									"ix": 5,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 0,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.064,
																0.571
															],
															[
																17.827,
																17.827
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.058,
																-0.574
															],
															[
																-3.015,
																-27.002
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																171.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-9.707,
																-33.733
															],
															[
																-31.126,
																-42.354
															],
															[
																-37.8,
																-54.486
															],
															[
																-11.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																95.356,
																-87.491
															],
															[
																158.535,
																-55.485
															],
															[
																191.873,
																25
															],
															[
																158.535,
																105.484
															],
															[
																93.944,
																137.774
															],
															[
																93.943,
																148.738
															],
															[
																202.764,
																25
															],
															[
																202.764,
																24.999
															],
															[
																166.236,
																-63.187
															],
															[
																94.725,
																-98.503
															],
															[
																94.543,
																-100.219
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-11.88,
																-97.685
															],
															[
																-40.955,
																-83.825
															],
															[
																-48.456,
																-52.238
															],
															[
																-38.828,
																-34.653
															],
															[
																-9.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																171.892
															],
															[
																78.388,
																188.132
															],
															[
																62.147,
																194.858
															],
															[
																45.908,
																188.132
															],
															[
																39.181,
																171.892
															],
															[
																39.181,
																146.286
															],
															[
																27.612,
																146.149
															],
															[
																27.612,
																171.547
															],
															[
																4.301,
																194.858
															],
															[
																-12.183,
																188.031
															],
															[
																-19.011,
																171.547
															],
															[
																-19.011,
																145.601
															],
															[
																-30.084,
																145.471
															],
															[
																-30.084,
																171.302
															],
															[
																-36.91,
																187.783
															],
															[
																-53.391,
																194.609
															],
															[
																-69.872,
																187.782
															],
															[
																-76.699,
																171.301
															],
															[
																-76.699,
																144.922
															],
															[
																-87.786,
																144.792
															],
															[
																-87.786,
																171.551
															],
															[
																-111.094,
																194.858
															],
															[
																-127.574,
																188.032
															],
															[
																-134.401,
																171.551
															],
															[
																-134.401,
																145.778
															],
															[
																-124.035,
																145.778
															],
															[
																-89.836,
																111.579
															],
															[
																-99.853,
																87.397
															],
															[
																-105.601,
																82.805
															],
															[
																-89.587,
																53.878
															],
															[
																-99.603,
																29.696
															],
															[
																-105.591,
																24.957
															],
															[
																-89.836,
																-3.814
															],
															[
																-99.854,
																-28
															],
															[
																-106.001,
																-32.834
															],
															[
																-89.836,
																-61.661
															],
															[
																-99.753,
																-85.603
															],
															[
																-123.694,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-163.906,
																-95.519
															],
															[
																-197.764,
																-61.662
															],
															[
																-187.847,
																-37.72
															],
															[
																-181.6,
																-32.835
															],
															[
																-197.764,
																-3.815
															],
															[
																-187.746,
																20.371
															],
															[
																-181.76,
																25.108
															],
															[
																-197.514,
																53.878
															],
															[
																-187.497,
																78.06
															],
															[
																-181.749,
																82.652
															],
															[
																-197.764,
																111.58
															],
															[
																-187.747,
																135.762
															],
															[
																-163.565,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																171.551
															],
															[
																-135.276,
																195.733
															],
															[
																-111.094,
																205.75
															],
															[
																-82.167,
																189.735
															],
															[
																-77.574,
																195.483
															],
															[
																-53.391,
																205.5
															],
															[
																-24.622,
																189.746
															],
															[
																-19.885,
																195.732
															],
															[
																4.301,
																205.75
															],
															[
																33.321,
																189.585
															],
															[
																38.207,
																195.833
															],
															[
																62.148,
																205.75
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"t": 95,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.064,
																0.571
															],
															[
																17.827,
																17.827
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.058,
																-0.574
															],
															[
																-3.015,
																-27.002
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																171.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-9.707,
																-33.733
															],
															[
																-31.126,
																-42.354
															],
															[
																-37.8,
																-54.486
															],
															[
																-11.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																95.356,
																-87.491
															],
															[
																158.535,
																-55.485
															],
															[
																191.873,
																25
															],
															[
																158.535,
																105.484
															],
															[
																93.944,
																137.774
															],
															[
																93.943,
																148.738
															],
															[
																202.764,
																25
															],
															[
																202.764,
																24.999
															],
															[
																166.236,
																-63.187
															],
															[
																94.725,
																-98.503
															],
															[
																94.543,
																-100.219
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-11.88,
																-97.685
															],
															[
																-40.955,
																-83.825
															],
															[
																-48.456,
																-52.238
															],
															[
																-38.828,
																-34.653
															],
															[
																-9.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																171.892
															],
															[
																78.388,
																188.132
															],
															[
																62.147,
																194.858
															],
															[
																45.908,
																188.132
															],
															[
																39.181,
																171.892
															],
															[
																39.181,
																146.286
															],
															[
																27.612,
																146.149
															],
															[
																27.612,
																171.547
															],
															[
																4.301,
																194.858
															],
															[
																-12.183,
																188.031
															],
															[
																-19.011,
																171.547
															],
															[
																-19.011,
																145.601
															],
															[
																-30.084,
																145.471
															],
															[
																-30.084,
																171.302
															],
															[
																-36.91,
																187.783
															],
															[
																-53.391,
																194.609
															],
															[
																-69.872,
																187.782
															],
															[
																-76.699,
																171.301
															],
															[
																-76.699,
																144.922
															],
															[
																-87.786,
																144.792
															],
															[
																-87.786,
																171.551
															],
															[
																-111.094,
																194.858
															],
															[
																-127.574,
																188.032
															],
															[
																-134.401,
																171.551
															],
															[
																-134.401,
																145.778
															],
															[
																-124.035,
																145.778
															],
															[
																-89.836,
																111.579
															],
															[
																-99.853,
																87.397
															],
															[
																-105.601,
																82.805
															],
															[
																-89.587,
																53.878
															],
															[
																-99.603,
																29.696
															],
															[
																-105.591,
																24.957
															],
															[
																-89.836,
																-3.814
															],
															[
																-99.854,
																-28
															],
															[
																-106.001,
																-32.834
															],
															[
																-89.836,
																-61.661
															],
															[
																-99.753,
																-85.603
															],
															[
																-123.694,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-163.906,
																-95.519
															],
															[
																-197.764,
																-61.662
															],
															[
																-187.847,
																-37.72
															],
															[
																-181.6,
																-32.835
															],
															[
																-197.764,
																-3.815
															],
															[
																-187.746,
																20.371
															],
															[
																-181.76,
																25.108
															],
															[
																-197.514,
																53.878
															],
															[
																-187.497,
																78.06
															],
															[
																-181.749,
																82.652
															],
															[
																-197.764,
																111.58
															],
															[
																-187.747,
																135.762
															],
															[
																-163.565,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																171.551
															],
															[
																-135.276,
																195.733
															],
															[
																-111.094,
																205.75
															],
															[
																-82.167,
																189.735
															],
															[
																-77.574,
																195.483
															],
															[
																-53.391,
																205.5
															],
															[
																-24.622,
																189.746
															],
															[
																-19.885,
																195.732
															],
															[
																4.301,
																205.75
															],
															[
																33.321,
																189.585
															],
															[
																38.207,
																195.833
															],
															[
																62.148,
																205.75
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 110,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.059,
																0.533
															],
															[
																17.852,
																17.852
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.054,
																-0.536
															],
															[
																-3.001,
																-27.049
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																166.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-14.707,
																-33.733
															],
															[
																-36.126,
																-42.354
															],
															[
																-42.8,
																-54.486
															],
															[
																-16.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																90.356,
																-87.491
															],
															[
																153.535,
																-55.485
															],
															[
																186.873,
																25
															],
															[
																153.535,
																105.484
															],
															[
																88.944,
																137.774
															],
															[
																88.943,
																148.738
															],
															[
																197.764,
																25
															],
															[
																197.764,
																24.999
															],
															[
																161.236,
																-63.187
															],
															[
																89.663,
																-98.503
															],
															[
																94.555,
																-100.107
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-16.88,
																-97.685
															],
															[
																-45.955,
																-83.825
															],
															[
																-53.456,
																-52.238
															],
															[
																-43.828,
																-34.653
															],
															[
																-14.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																166.892
															],
															[
																78.388,
																183.132
															],
															[
																62.147,
																189.858
															],
															[
																45.908,
																183.132
															],
															[
																39.181,
																166.892
															],
															[
																39.181,
																141.286
															],
															[
																27.612,
																141.149
															],
															[
																27.612,
																166.547
															],
															[
																4.301,
																189.858
															],
															[
																-12.183,
																183.031
															],
															[
																-19.011,
																166.547
															],
															[
																-19.011,
																140.601
															],
															[
																-30.084,
																140.471
															],
															[
																-30.084,
																166.302
															],
															[
																-36.91,
																182.783
															],
															[
																-53.391,
																189.609
															],
															[
																-69.872,
																182.782
															],
															[
																-76.699,
																166.301
															],
															[
																-76.699,
																139.922
															],
															[
																-87.786,
																139.836
															],
															[
																-87.786,
																166.551
															],
															[
																-111.094,
																189.858
															],
															[
																-127.574,
																183.032
															],
															[
																-134.401,
																166.551
															],
															[
																-134.401,
																145.778
															],
															[
																-116.535,
																145.778
															],
															[
																-82.336,
																111.579
															],
															[
																-92.353,
																87.397
															],
															[
																-98.101,
																82.805
															],
															[
																-82.087,
																53.878
															],
															[
																-92.103,
																29.696
															],
															[
																-98.091,
																24.957
															],
															[
																-82.336,
																-3.814
															],
															[
																-92.354,
																-28
															],
															[
																-98.501,
																-32.834
															],
															[
																-82.336,
																-61.661
															],
															[
																-92.253,
																-85.603
															],
															[
																-116.194,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-156.406,
																-95.519
															],
															[
																-190.264,
																-61.662
															],
															[
																-180.347,
																-37.72
															],
															[
																-174.1,
																-32.835
															],
															[
																-190.264,
																-3.815
															],
															[
																-180.246,
																20.371
															],
															[
																-174.26,
																25.108
															],
															[
																-190.014,
																53.878
															],
															[
																-179.997,
																78.06
															],
															[
																-174.249,
																82.652
															],
															[
																-190.264,
																111.58
															],
															[
																-180.247,
																135.762
															],
															[
																-156.065,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																166.551
															],
															[
																-135.276,
																190.733
															],
															[
																-111.094,
																200.75
															],
															[
																-82.167,
																184.735
															],
															[
																-77.574,
																190.483
															],
															[
																-53.391,
																200.5
															],
															[
																-24.622,
																184.746
															],
															[
																-19.885,
																190.732
															],
															[
																4.301,
																200.75
															],
															[
																33.321,
																184.585
															],
															[
																38.207,
																190.833
															],
															[
																62.148,
																200.75
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.667,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 125,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.064,
																0.571
															],
															[
																17.827,
																17.827
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.058,
																-0.574
															],
															[
																-3.015,
																-27.002
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																171.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-9.707,
																-33.733
															],
															[
																-31.126,
																-42.354
															],
															[
																-37.8,
																-54.486
															],
															[
																-11.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																95.356,
																-87.491
															],
															[
																158.535,
																-55.485
															],
															[
																191.873,
																25
															],
															[
																158.535,
																105.484
															],
															[
																93.944,
																137.774
															],
															[
																93.943,
																148.738
															],
															[
																202.764,
																25
															],
															[
																202.764,
																24.999
															],
															[
																166.236,
																-63.187
															],
															[
																94.725,
																-98.503
															],
															[
																94.543,
																-100.219
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-11.88,
																-97.685
															],
															[
																-40.955,
																-83.825
															],
															[
																-48.456,
																-52.238
															],
															[
																-38.828,
																-34.653
															],
															[
																-9.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																171.892
															],
															[
																78.388,
																188.132
															],
															[
																62.147,
																194.858
															],
															[
																45.908,
																188.132
															],
															[
																39.181,
																171.892
															],
															[
																39.181,
																146.286
															],
															[
																27.612,
																146.149
															],
															[
																27.612,
																171.547
															],
															[
																4.301,
																194.858
															],
															[
																-12.183,
																188.031
															],
															[
																-19.011,
																171.547
															],
															[
																-19.011,
																145.601
															],
															[
																-30.084,
																145.471
															],
															[
																-30.084,
																171.302
															],
															[
																-36.91,
																187.783
															],
															[
																-53.391,
																194.609
															],
															[
																-69.872,
																187.782
															],
															[
																-76.699,
																171.301
															],
															[
																-76.699,
																144.922
															],
															[
																-87.786,
																144.792
															],
															[
																-87.786,
																171.551
															],
															[
																-111.094,
																194.858
															],
															[
																-127.574,
																188.032
															],
															[
																-134.401,
																171.551
															],
															[
																-134.401,
																145.778
															],
															[
																-124.035,
																145.778
															],
															[
																-89.836,
																111.579
															],
															[
																-99.853,
																87.397
															],
															[
																-105.601,
																82.805
															],
															[
																-89.587,
																53.878
															],
															[
																-99.603,
																29.696
															],
															[
																-105.591,
																24.957
															],
															[
																-89.836,
																-3.814
															],
															[
																-99.854,
																-28
															],
															[
																-106.001,
																-32.834
															],
															[
																-89.836,
																-61.661
															],
															[
																-99.753,
																-85.603
															],
															[
																-123.694,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-163.906,
																-95.519
															],
															[
																-197.764,
																-61.662
															],
															[
																-187.847,
																-37.72
															],
															[
																-181.6,
																-32.835
															],
															[
																-197.764,
																-3.815
															],
															[
																-187.746,
																20.371
															],
															[
																-181.76,
																25.108
															],
															[
																-197.514,
																53.878
															],
															[
																-187.497,
																78.06
															],
															[
																-181.749,
																82.652
															],
															[
																-197.764,
																111.58
															],
															[
																-187.747,
																135.762
															],
															[
																-163.565,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																171.551
															],
															[
																-135.276,
																195.733
															],
															[
																-111.094,
																205.75
															],
															[
																-82.167,
																189.735
															],
															[
																-77.574,
																195.483
															],
															[
																-53.391,
																205.5
															],
															[
																-24.622,
																189.746
															],
															[
																-19.885,
																195.732
															],
															[
																4.301,
																205.75
															],
															[
																33.321,
																189.585
															],
															[
																38.207,
																195.833
															],
															[
																62.148,
																205.75
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"t": 140,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.059,
																0.533
															],
															[
																17.852,
																17.852
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.054,
																-0.536
															],
															[
																-3.001,
																-27.049
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																166.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-14.707,
																-33.733
															],
															[
																-36.126,
																-42.354
															],
															[
																-42.8,
																-54.486
															],
															[
																-16.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																90.356,
																-87.491
															],
															[
																153.535,
																-55.485
															],
															[
																186.873,
																25
															],
															[
																153.535,
																105.484
															],
															[
																88.944,
																137.774
															],
															[
																88.943,
																148.738
															],
															[
																197.764,
																25
															],
															[
																197.764,
																24.999
															],
															[
																161.236,
																-63.187
															],
															[
																89.663,
																-98.503
															],
															[
																94.555,
																-100.107
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-16.88,
																-97.685
															],
															[
																-45.955,
																-83.825
															],
															[
																-53.456,
																-52.238
															],
															[
																-43.828,
																-34.653
															],
															[
																-14.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																166.892
															],
															[
																78.388,
																183.132
															],
															[
																62.147,
																189.858
															],
															[
																45.908,
																183.132
															],
															[
																39.181,
																166.892
															],
															[
																39.181,
																141.286
															],
															[
																27.612,
																141.149
															],
															[
																27.612,
																166.547
															],
															[
																4.301,
																189.858
															],
															[
																-12.183,
																183.031
															],
															[
																-19.011,
																166.547
															],
															[
																-19.011,
																140.601
															],
															[
																-30.084,
																140.471
															],
															[
																-30.084,
																166.302
															],
															[
																-36.91,
																182.783
															],
															[
																-53.391,
																189.609
															],
															[
																-69.872,
																182.782
															],
															[
																-76.699,
																166.301
															],
															[
																-76.699,
																139.922
															],
															[
																-87.786,
																139.836
															],
															[
																-87.786,
																166.551
															],
															[
																-111.094,
																189.858
															],
															[
																-127.574,
																183.032
															],
															[
																-134.401,
																166.551
															],
															[
																-134.401,
																145.778
															],
															[
																-116.535,
																145.778
															],
															[
																-82.336,
																111.579
															],
															[
																-92.353,
																87.397
															],
															[
																-98.101,
																82.805
															],
															[
																-82.087,
																53.878
															],
															[
																-92.103,
																29.696
															],
															[
																-98.091,
																24.957
															],
															[
																-82.336,
																-3.814
															],
															[
																-92.354,
																-28
															],
															[
																-98.501,
																-32.834
															],
															[
																-82.336,
																-61.661
															],
															[
																-92.253,
																-85.603
															],
															[
																-116.194,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-156.406,
																-95.519
															],
															[
																-190.264,
																-61.662
															],
															[
																-180.347,
																-37.72
															],
															[
																-174.1,
																-32.835
															],
															[
																-190.264,
																-3.815
															],
															[
																-180.246,
																20.371
															],
															[
																-174.26,
																25.108
															],
															[
																-190.014,
																53.878
															],
															[
																-179.997,
																78.06
															],
															[
																-174.249,
																82.652
															],
															[
																-190.264,
																111.58
															],
															[
																-180.247,
																135.762
															],
															[
																-156.065,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																166.551
															],
															[
																-135.276,
																190.733
															],
															[
																-111.094,
																200.75
															],
															[
																-82.167,
																184.735
															],
															[
																-77.574,
																190.483
															],
															[
																-53.391,
																200.5
															],
															[
																-24.622,
																184.746
															],
															[
																-19.885,
																190.732
															],
															[
																4.301,
																200.75
															],
															[
																33.321,
																184.585
															],
															[
																38.207,
																190.833
															],
															[
																62.148,
																200.75
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 155,
												"s": [
													{
														"i": [
															[
																0.001,
																18.699
															],
															[
																0,
																0
															],
															[
																7.14,
																7.139
															],
															[
																10.869,
																0
															],
															[
																0,
																0
															],
															[
																5.453,
																5.453
															],
															[
																1.001,
																4.744
															],
															[
																-16.539,
																-0.001
															],
															[
																0.004,
																0.344
															],
															[
																0.001,
																0.02
															],
															[
																-17.361,
																-17.361
															],
															[
																0,
																-30.404
															],
															[
																21.498,
																-21.498
															],
															[
																24.541,
																-3.312
															],
															[
																0,
																0
															],
															[
																0,
																63.64
															],
															[
																0,
																0
															],
															[
																22.569,
																22.569
															],
															[
																27.757,
																3.713
															],
															[
																0.064,
																0.571
															],
															[
																17.827,
																17.827
															],
															[
																37.343,
																-1.034
															],
															[
																9.539,
																-59.227
															],
															[
																0,
																0
															],
															[
																-54.108,
																1.5
															],
															[
																-21.89,
																-21.89
															],
															[
																-2.615,
																-23.906
															],
															[
																31.329,
																-0.086
															],
															[
																7.144,
																-8.809
															],
															[
																-2.377,
																-11.265
															],
															[
																-4.907,
																-4.907
															],
															[
																-11,
																0
															],
															[
																0,
																0
															],
															[
																-5.376,
																-5.375
															],
															[
																0.014,
																-7.496
															],
															[
																0,
																0
															],
															[
																0.001,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.021,
																-0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.338,
																-4.338
															],
															[
																6.136,
																0
															],
															[
																4.338,
																4.338
															],
															[
																0,
																6.135
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.854,
																0
															],
															[
																4.403,
																4.403
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.402,
																-4.402
															],
															[
																6.226,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.227
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.852,
																0
															],
															[
																4.402,
																4.402
															],
															[
																0,
																6.226
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																18.888
															],
															[
																6.19,
																6.189
															],
															[
																2.075,
																1.332
															],
															[
																0,
																12.197
															],
															[
																6.188,
																6.189
															],
															[
																2.166,
																1.365
															],
															[
																0,
																12.089
															],
															[
																6.189,
																6.19
															],
															[
																2.226,
																1.386
															],
															[
																-0.001,
																12.204
															],
															[
																6.127,
																6.127
															],
															[
																9.35,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-18.699
															],
															[
																-6.127,
																-6.127
															],
															[
																-2.265,
																-1.393
															],
															[
																0,
																-12.26
															],
															[
																-6.189,
																-6.19
															],
															[
																-2.164,
																-1.364
															],
															[
																0,
																-12.088
															],
															[
																-6.189,
																-6.189
															],
															[
																-2.075,
																-1.331
															],
															[
																0,
																-12.197
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.444,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-6.189,
																-6.189
															],
															[
																-9.443,
																0
															],
															[
																-6.054,
																9.61
															],
															[
																-1.735,
																-1.735
															],
															[
																-9.444,
																0
															],
															[
																-6.082,
																9.467
															],
															[
																-1.801,
																-1.801
															],
															[
																-9.445,
																-0.001
															],
															[
																-6.038,
																9.693
															],
															[
																-1.872,
																-1.871
															],
															[
																-9.35,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0.022,
																-10.896
															],
															[
																-7.121,
																-7.122
															],
															[
																0,
																0
															],
															[
																-8.057,
																0
															],
															[
																-3.281,
																-3.281
															],
															[
																-3.624,
																-17.175
															],
															[
																0,
																0
															],
															[
																0,
																-0.019
															],
															[
																23.83,
																3.61
															],
															[
																21.498,
																21.498
															],
															[
																0,
																30.403
															],
															[
																-17.81,
																17.81
															],
															[
																0,
																0
															],
															[
																61.58,
																-7.617
															],
															[
																0,
																0
															],
															[
																0,
																-34.438
															],
															[
																-18.857,
																-18.856
															],
															[
																-0.058,
																-0.574
															],
															[
																-3.015,
																-27.002
															],
															[
																-23.53,
																-23.53
															],
															[
																-61.285,
																1.698
															],
															[
																0,
																0
															],
															[
																9.486,
																-54.405
															],
															[
																33.188,
																-0.919
															],
															[
																16.841,
																16.841
															],
															[
																-20.228,
																0.179
															],
															[
																-11.333,
																-0.001
															],
															[
																-7.145,
																8.808
															],
															[
																1.391,
																6.597
															],
															[
																7.506,
																7.506
															],
															[
																0,
																0
															],
															[
																7.603,
																0
															],
															[
																5.391,
																5.391
															],
															[
																0,
																0
															],
															[
																-0.001,
																-0.001
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.021,
																0.051
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.001,
																6.135
															],
															[
																-4.338,
																4.338
															],
															[
																-6.134,
																0
															],
															[
																-4.338,
																-4.338
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.854
															],
															[
																-6.227,
																0
															],
															[
																-4.403,
																-4.403
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.226
															],
															[
																-4.402,
																4.402
															],
															[
																-6.226,
																0
															],
															[
																-4.402,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																12.852
															],
															[
																-6.226,
																0.001
															],
															[
																-4.403,
																-4.402
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																18.887,
																0.001
															],
															[
																0,
																-9.444
															],
															[
																-1.736,
																-1.735
															],
															[
																9.61,
																-6.054
															],
															[
																0,
																-9.444
															],
															[
																-1.802,
																-1.801
															],
															[
																9.467,
																-6.083
															],
															[
																-0.001,
																-9.445
															],
															[
																-1.845,
																-1.845
															],
															[
																9.685,
																-5.959
															],
															[
																0,
																-9.35
															],
															[
																-6.127,
																-6.127
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-18.699,
																0
															],
															[
																0,
																9.35
															],
															[
																1.871,
																1.871
															],
															[
																-9.692,
																6.038
															],
															[
																0.001,
																9.445
															],
															[
																1.801,
																1.8
															],
															[
																-9.466,
																6.082
															],
															[
																0,
																9.444
															],
															[
																1.735,
																1.735
															],
															[
																-9.61,
																6.055
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.188
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																9.444
															],
															[
																6.189,
																6.189
															],
															[
																12.197,
																0
															],
															[
																1.332,
																2.075
															],
															[
																6.189,
																6.189
															],
															[
																12.088,
																0
															],
															[
																1.364,
																2.165
															],
															[
																6.19,
																6.19
															],
															[
																12.26,
																0
															],
															[
																1.393,
																2.266
															],
															[
																6.127,
																6.127
															],
															[
																18.699,
																0
															]
														],
														"v": [
															[
																96.005,
																171.892
															],
															[
																97.726,
																5.699
															],
															[
																86.199,
																-22.206
															],
															[
																58.372,
																-33.732
															],
															[
																-9.707,
																-33.733
															],
															[
																-31.126,
																-42.354
															],
															[
																-37.8,
																-54.486
															],
															[
																-11.881,
																-86.794
															],
															[
																95.358,
																-87.433
															],
															[
																95.356,
																-87.491
															],
															[
																158.535,
																-55.485
															],
															[
																191.873,
																25
															],
															[
																158.535,
																105.484
															],
															[
																93.944,
																137.774
															],
															[
																93.943,
																148.738
															],
															[
																202.764,
																25
															],
															[
																202.764,
																24.999
															],
															[
																166.236,
																-63.187
															],
															[
																94.725,
																-98.503
															],
															[
																94.543,
																-100.219
															],
															[
																64.181,
																-168.531
															],
															[
																-30.488,
																-204.716
															],
															[
																-149.929,
																-95.519
															],
															[
																-138.906,
																-95.52
															],
															[
																-30.187,
																-193.829
															],
															[
																56.48,
																-160.83
															],
															[
																83.821,
																-98.12
															],
															[
																-11.88,
																-97.685
															],
															[
																-40.955,
																-83.825
															],
															[
																-48.456,
																-52.238
															],
															[
																-38.828,
																-34.653
															],
															[
																-9.708,
																-22.842
															],
															[
																58.372,
																-22.841
															],
															[
																78.498,
																-14.505
															],
															[
																86.836,
																5.55
															],
															[
																85.449,
																107.157
															],
															[
																85.446,
																107.155
															],
															[
																85.441,
																107.721
															],
															[
																85.265,
																120.605
															],
															[
																85.334,
																120.745
															],
															[
																85.12,
																146.826
															],
															[
																85.114,
																146.826
															],
															[
																85.114,
																171.892
															],
															[
																78.388,
																188.132
															],
															[
																62.147,
																194.858
															],
															[
																45.908,
																188.132
															],
															[
																39.181,
																171.892
															],
															[
																39.181,
																146.286
															],
															[
																27.612,
																146.149
															],
															[
																27.612,
																171.547
															],
															[
																4.301,
																194.858
															],
															[
																-12.183,
																188.031
															],
															[
																-19.011,
																171.547
															],
															[
																-19.011,
																145.601
															],
															[
																-30.084,
																145.471
															],
															[
																-30.084,
																171.302
															],
															[
																-36.91,
																187.783
															],
															[
																-53.391,
																194.609
															],
															[
																-69.872,
																187.782
															],
															[
																-76.699,
																171.301
															],
															[
																-76.699,
																144.922
															],
															[
																-87.786,
																144.792
															],
															[
																-87.786,
																171.551
															],
															[
																-111.094,
																194.858
															],
															[
																-127.574,
																188.032
															],
															[
																-134.401,
																171.551
															],
															[
																-134.401,
																145.778
															],
															[
																-124.035,
																145.778
															],
															[
																-89.836,
																111.579
															],
															[
																-99.853,
																87.397
															],
															[
																-105.601,
																82.805
															],
															[
																-89.587,
																53.878
															],
															[
																-99.603,
																29.696
															],
															[
																-105.591,
																24.957
															],
															[
																-89.836,
																-3.814
															],
															[
																-99.854,
																-28
															],
															[
																-106.001,
																-32.834
															],
															[
																-89.836,
																-61.661
															],
															[
																-99.753,
																-85.603
															],
															[
																-123.694,
																-95.519
															],
															[
																-149.929,
																-95.519
															],
															[
																-163.906,
																-95.519
															],
															[
																-197.764,
																-61.662
															],
															[
																-187.847,
																-37.72
															],
															[
																-181.6,
																-32.835
															],
															[
																-197.764,
																-3.815
															],
															[
																-187.746,
																20.371
															],
															[
																-181.76,
																25.108
															],
															[
																-197.514,
																53.878
															],
															[
																-187.497,
																78.06
															],
															[
																-181.749,
																82.652
															],
															[
																-197.764,
																111.58
															],
															[
																-187.747,
																135.762
															],
															[
																-163.565,
																145.779
															],
															[
																-145.292,
																145.779
															],
															[
																-145.292,
																171.551
															],
															[
																-135.276,
																195.733
															],
															[
																-111.094,
																205.75
															],
															[
																-82.167,
																189.735
															],
															[
																-77.574,
																195.483
															],
															[
																-53.391,
																205.5
															],
															[
																-24.622,
																189.746
															],
															[
																-19.885,
																195.732
															],
															[
																4.301,
																205.75
															],
															[
																33.321,
																189.585
															],
															[
																38.207,
																195.833
															],
															[
																62.148,
																205.75
															]
														],
														"c": true
													}
												]
											}
										],
										"ix": 2
									},
									"nm": "Hand",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509817362,
											1,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											205.979,
											206.242
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 7,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 300,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "Partnership_handshake_naimation",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": -45,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						210,
						179,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						210,
						225,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						104.13,
						104.13,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 420,
			"h": 450,
			"ip": 0,
			"op": 300,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Partnership_handshake.json
// module id = 55
// module chunks = 0